import { onBeforeUnmount, onMounted } from 'vue'

// Reads the PrimeVue theme tokens at call time — call inside the render
// function so a dark/light switch picks up the current values.
export function readChartTheme() {
  const s = getComputedStyle(document.documentElement)
  const get = (token, fallback) => s.getPropertyValue(token).trim() || fallback
  return {
    isDark:      document.documentElement.classList.contains('my-app-dark'),
    textColor:   get('--p-text-color', '#333333'),
    textMuted:   get('--p-text-color-secondary', '#6c757d'),
    gridColor:   get('--p-content-border-color', '#e0e0e0'),
    contentBg:   get('--p-content-background', '#ffffff'),
    primary:     get('--p-primary-color', '#269856'),
    surface200:  get('--p-surface-200', '#f4f4f4'),
    surface300:  get('--p-surface-300', '#dcdcdc'),
    surface400:  get('--p-surface-400', '#a8a8a8'),
    surface700:  get('--p-surface-700', '#3f3f46'),
    surface800:  get('--p-surface-800', '#27272a'),
  }
}

// Re-runs `render` when the container resizes or the theme class on <html>
// changes (dark/light toggle). ResizeObserver fires once on observe, which
// also triggers the initial render.
export function useD3Container(elRef, render) {
  let resizeObserver = null
  let themeObserver  = null
  let frame = 0

  // Render in den nächsten Animation-Frame verschieben (und pro Frame bündeln):
  // synchrone SVG-Mutationen im Observer-Callback ändern selbst das Layout und
  // lösen sonst "ResizeObserver loop completed with undelivered notifications" aus.
  const scheduleRender = () => {
    cancelAnimationFrame(frame)
    frame = requestAnimationFrame(() => render())
  }

  onMounted(() => {
    if (!elRef.value) return
    resizeObserver = new ResizeObserver(scheduleRender)
    resizeObserver.observe(elRef.value)
    themeObserver = new MutationObserver(scheduleRender)
    themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
  })

  onBeforeUnmount(() => {
    cancelAnimationFrame(frame)
    resizeObserver?.disconnect()
    themeObserver?.disconnect()
  })
}
